import React, { useEffect, useState } from 'react'
import ChartistGraph, { ChartitGraphProps } from 'react-chartist'
import styled from 'styled-components'
import { MonthlyDataSet } from '../../../Data'
import { dataSetColors } from './SavingsGrowthTable'
import { useWidget } from './WidgetContext'

interface ChartConfig {
  value: number
  className: string
}

const StyledChart = styled(ChartistGraph)`
  .ct-series {
    &.INT {
      fill: ${dataSetColors.INT};
    }
    &.FAS {
      fill: ${dataSetColors.FAS};
    }
    &.SIFI {
      fill: ${dataSetColors.SIFI};
    }
    &.RUP {
      fill: ${dataSetColors.RUP};
    }
    &.OTHER {
      fill: ${dataSetColors.OTHER};
    }
  }
`

const getChartOptions = (chartData: MonthlyDataSet[]): ChartitGraphProps => {
  const series: ChartConfig[] = chartData.map((e: MonthlyDataSet) => {
    return {
      value: e[1],
      className: e[0],
    }
  })

  return {
    data: {
      series,
    },
    options: {
      height: '110px',
      width: '110px',
      chartPadding: 12,
      showLabel: false,
      startAngle: 230,
    },
    type: 'PieChart',
  }
}

const SavingsGrowthChart: React.FC = () => {
  const { stkSummaryData } = useWidget()
  const [columnData, setColumnData] = useState(
    stkSummaryData?.growthChart.monthToDateSummary?.dataSets,
  )

  useEffect(() => {
    // istanbul ignore next
    setColumnData(stkSummaryData?.growthChart.monthToDateSummary?.dataSets)
  }, [stkSummaryData])

  const data = columnData ? getChartOptions(columnData) : null

  return data ? (
    <div data-testid="stk-savings-growth-chart" aria-hidden>
      <StyledChart data={data.data} options={data.options} type={data.type} />
    </div>
  ) : null
}

export default SavingsGrowthChart
